import Button from '@components/Button';
import CtaLayout from '@components/CtaLayout';
import Header from '@components/Header';
import { GiftItemType } from '@models/gift';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType, useFlow } from '@stackflow/react';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import Comment from './components/Comment';
import Complete from './components/Complete';
import GiftOrderInfo from './components/GiftOrderInfo';
import useGiftOrder from './hooks/useGiftOrder';

interface Params {
    orderNo: string;
}

declare module '@stackflow/config' {
    interface Register {
        GiftOrderCompleteActivity: Params;
    }
}

const GiftOrderCompleteActivity: ActivityComponentType<'GiftOrderCompleteActivity'> = ({ params }) => {
    const { orderNo } = params;
    const { t } = useTranslation('gift');
    const giftOrder = useGiftOrder(orderNo);
    const { replace, push } = useFlow();
    const onConfirmClick = () => {
        replace('MainActivity', {}, { animate: false });
        push('GiftsActivity', { type: 'MAIN' });
    };
    return (
        <AppScreen preventSwipeBack >
            <CtaLayout header={<Header title={t('giftOrderComplete.title')}
                noBackIcon />}
            noFooterBorder
            footer={<Button fullWidth
                onClick={onConfirmClick}>
                {t('giftOrderComplete.confirm')}
            </Button>} >
                <Comment/>
                {giftOrder && (
                    <Fragment>
                        <GiftOrderInfo giftOrder={giftOrder} />
                        {giftOrder.detail.giftItem.giftItemType === GiftItemType.CASH && (
                            <Complete response={giftOrder}/>
                        )}
                    </Fragment>
                )}
            </CtaLayout>
        </AppScreen>
    );
};

export default GiftOrderCompleteActivity;
